/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/language'
export default icon
